import React from "react";

const Error = () => {
  return <div className="alert alert-danger">oops!! something went wrong</div>;
};

export default Error;
